var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpdateRelistIcon = function SvgUpdateRelistIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.041 1.363A10 10 0 1 0 20 10a1 1 0 0 0-2 0 8 8 0 1 1-4.209-7.045l-.417.053a1 1 0 1 0 .252 1.984l2.862-.363a1 1 0 0 0 .865-1.128L16.991.864a1 1 0 0 0-1.982.272ZM9 8.882A1.5 1.5 0 1 0 11.118 11H14.5a1 1 0 1 0 0-2h-3.382A1.658 1.658 0 0 0 11 8.882V4a1 1 0 1 0-2 0Z",
    fillRule: "evenodd"
  })));
};
export default SvgUpdateRelistIcon;